import type { PageContext } from './types';

/**
 * Collects basic page context (URL + title) from the host document.
 * Silent fail on SSR / missing globals. Values are truncated so we never
 * ship absurdly long strings to the server.
 */
export function collectPage(): PageContext | undefined {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return undefined;
  }
  const url = (location.href || '').slice(0, 2048);
  if (!url) return undefined;
  const rawTitle = (document.title || '').slice(0, 300);
  const title = rawTitle.length > 0 ? rawTitle : undefined;
  return { url, title };
}
